__turbopack_context__.v({
  "main": "RichText-module-scss-module__RvMlKW__main",
  "no-default-body-style": "RichText-module-scss-module__RvMlKW__no-default-body-style",
  "pdf": "RichText-module-scss-module__RvMlKW__pdf",
});
